module.exports = __webpack_public_path__ + "static/media/menu-icon-beyond.cc078bd0.png";